export const config = {
    /**
     * Whether to perform access checks
     */
    checkAccess: true,
    /**
     * Whether to mark a file as dirty after updating its `atime` when read from
     */
    updateOnRead: true,
    /**
     * Whether to immediately sync when files are changed
     */
    syncImmediately: true,
    /**
     * If a file's buffer is not large enough to store content when writing and the buffer can't be resized, reuse the buffer passed to write()
     */
    unsafeBufferReplace: false,
};
